import { html } from "lit";
var icon_notification_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M13.356 27.002c.705.621 1.63.998 2.644.998a3.988 3.988 0 002.644-.998h2.552A5.998 5.998 0 0116 30a5.996 5.996 0 01-5.196-2.999l2.552.001zM16 1a1 1 0 011 1v1.05c4.942.49 8.84 4.586 8.996 9.67L26 13v5.171l1.121 1.122c.516.516.825 1.2.872 1.923l.007.198V22a3 3 0 01-3 3H7a3 3 0 01-3-3v-.586a3 3 0 01.879-2.121L6 18.17V13c0-5.185 3.946-9.448 8.999-9.95L15 2a1 1 0 011-1zm0 4a8 8 0 00-8 8v5.586c0 .265-.105.52-.293.707l-1.414 1.414a1 1 0 00-.293.707V22a1 1 0 001 1h18a1 1 0 001-1v-.586a.997.997 0 00-.293-.707l-1.414-1.414a1 1 0 01-.293-.707V13l-.004-.25A8 8 0 0016 5z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_notification_default as default
};
//# sourceMappingURL=icon-notification.js.map
